export default __webpack_public_path__ + "static/media/Febrero2024(360x600).2924865e.webp";